const buildMessages = responseData => {
  if (responseData?.threads_list) {
    const messageList = responseData.threads_list.map(thread => {
      const {
        subject,
        latestMessage,
        consultation_id,
        updatedAt,
        isPrimary,
        url_request_data,
        viewed,
        message_id
      } = thread;
      const data = {
        childrenData: {
          componentName: "Message",
          subject,
          latestMessage,
          viewed,
          message_id
        },
        key: "selectedData",
        type: "listItemWrapper",
        title: "",
        selectedData: {
          consultation_id,
          updated_at: updatedAt,
          is_primary: isPrimary,
          latest_message: latestMessage,
          url_request_data,
          subject
        },
        childrenType: "message"
      };

      return data;
    });

    return messageList;
  }
  return [];
};

export default buildMessages;
